import React, { FC, useEffect, useState } from 'react'
import ToolsButton from 'components/Owner/Tools/ToolsButton'
import ToolsLabel from 'components/Owner/Tools/ToolsLabel'
import CardHeader from 'components/Owner/Tools/CardHeader'
import ExternalLinkLaunch from 'assets/svgs/external-link-secondary.svg'
import GradientCircleNotchIcon from 'components/Common/SvgIcons/GradientCircleNotchIcon'
import { CardBlock } from 'components/Owner/Tools/style'

import { Tool, useDeauthenticateConnectorMutation } from '__generated__/api-types-and-hooks'
import useTenantId from 'hooks/useTenantId'
import { ampli } from 'ampli'

export interface IBlockProps {
  tool: Tool
  getOAuthUrlAction: (props: any) => void
  setActiveConnectingTool?: (tool: Tool) => void
  allowDisconnect?: boolean
  onDisconnect?: () => void
}

const Block: FC<IBlockProps> = ({
  tool,
  allowDisconnect = true,
  getOAuthUrlAction,
  setActiveConnectingTool,
  onDisconnect,
}) => {
  const [isConnected, setIsConnected] = useState(tool.isConnected)

  const tenantId = useTenantId()
  const {
    mutate,
    isLoading: isToolDisconnecting,
    data: toolDisconnectedResponse,
  } = useDeauthenticateConnectorMutation()

  useEffect(() => {
    if (toolDisconnectedResponse && !toolDisconnectedResponse?.deauthenticateConnector?.error) {
      setIsConnected(false)
      ampli.toolDisconnected({ name: tool.toolName ?? '' })
      if (onDisconnect) {
        onDisconnect()
      }
    }
    // eslint-disable-next-line
  }, [toolDisconnectedResponse])

  useEffect(() => {
    setIsConnected(tool.isConnected)
  }, [tool])

  const handleDisconnect = () => {
    mutate({ input: { connectorName: tool.toolName ?? '', tenantId: tenantId ?? '' } })
  }

  return (
    <>
      <CardBlock className="w-full xs:max-w-[100%] sm:max-w-[354px] h-[300px] flex flex-col border border-primary-outline rounded-[20px] bg-white pt-6">
        <CardHeader
          key={tool.id}
          tool={tool}
          isConnected={isConnected || false}
          isToolDisconnecting={isToolDisconnecting}
          handleDisconnect={handleDisconnect}
        />

        <div className="flex flex-col justify-between bg-secondary px-6 h-full rounded-b-[20px] pb-6">
          <ToolDisconnection isToolDisconnecting={isToolDisconnecting} />
          <ToolsLabel tool={tool} isToolDisconnecting={isToolDisconnecting} />
          <ToolsButton
            isConnected={isConnected || false}
            ExternalLinkLaunch={ExternalLinkLaunch}
            tool={tool}
            setActiveConnectingTool={setActiveConnectingTool}
            getOAuthUrlAction={getOAuthUrlAction}
          />
        </div>
      </CardBlock>
    </>
  )
}

export default Block

const ToolDisconnection = ({ isToolDisconnecting }) => {
  return (
    isToolDisconnecting && (
      <div className="flex flex-row">
        <GradientCircleNotchIcon width="30" height="30" />
        <div className="ml-2 my-auto font-semibold">Disconnecting</div>
      </div>
    )
  )
}
